// Shared avatar: shows photo if available, falls back to colored initial
const BG_COLORS = [
  'bg-blue-500', 'bg-purple-500', 'bg-green-500', 'bg-orange-500',
  'bg-pink-500', 'bg-teal-500', 'bg-indigo-500', 'bg-red-500',
]

function colorFromName(name = '') {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return BG_COLORS[Math.abs(hash) % BG_COLORS.length]
}

export default function Avatar({ src, name = '', size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-6 h-6 text-[10px]',
    sm: 'w-8 h-8 text-xs',
    md: 'w-9 h-9 text-sm',
    lg: 'w-11 h-11 text-base',
    xl: 'w-14 h-14 text-lg',
  }
  const initial = (name || '?').charAt(0).toUpperCase()
  const bg = colorFromName(name)
  const base = `rounded-full flex-shrink-0 overflow-hidden flex items-center justify-center font-bold text-white ${sizeClasses[size] || sizeClasses.md} ${className}`

  if (src) {
    return (
      <div className={base}>
        <img
          src={src}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.nextSibling.style.display = 'flex' }}
        />
        <span className={`${base} ${bg} hidden`}>{initial}</span>
      </div>
    )
  }

  return <div className={`${base} ${bg}`}>{initial}</div>
}
